import { Injectable } from '@angular/core';
import { EsPage } from '../../../../models/es-page';
import { Aggregate } from '../../../../models/aggregate';
import { CdxTask } from '../../../../models/cdx-task';
import { createAction, props, Store } from '@ngrx/store';

export class WkfSupervisionSearchResultConstantAction {
  static readonly LOAD_RESULT_ITEMS_START = '[WkfSupervisionSearch]: LOAD_RESULTS_START';
  static readonly LOAD_RESULT_ITEMS_SUCCEEDED = '[WkfSupervisionSearch]: LOAD_RESULTS_SUCCEEDED';
  static readonly LOAD_RESULT_ITEMS_FAILED = '[WkfSupervisionSearch]: LOAD_RESULTS_FAILED';
  static readonly ERROR_START = 'ERROR_START';

  static readonly LOAD_AGGREGATE_START = '[WkfSupervisionSearch]: LOAD_AGGREGATE_START';
  static readonly LOAD_AGGREGATE_SUCCEEDED = '[WkfSupervisionSearch]: LOAD_AGGREGATE_SUCCEEDED';
  static readonly LOAD_AGGREGATE_FAILED = '[WkfSupervisionSearch]: LOAD_AGGREGATE_FAILED';

  static readonly UPDATE_TASKS_START = '[WkfSupervisionSearch]: UPDATE_TASKS_START';
  static readonly UPDATE_TASKS_SUCCEEDED = '[WkfSupervisionSearch]: UPDATE_TASKS_SUCCEEDED';
  static readonly UPDATE_TASKS_FAILED = '[WkfSupervisionSearch]: UPDATE_TASKS_FAILED';

  static readonly UPDATE_TASK_SUCCEEDED = '[WkfSupervisionSearch]: UPDATE_TASK_SUCCEEDED';

  static readonly UPDATE_SOME_TASKS_START = '[WkfSupervisionSearch]: UPDATE_SOME_TASKS_START';
  static readonly UPDATE_SOME_TASKS_SUCCEEDED = '[WkfSupervisionSearch]: UPDATE_SOME_TASKS_SUCCEEDED';
  static readonly UPDATE_SOME_TASKS_FAILED = '[WkfSupervisionSearch]: UPDATE_SOME_TASKS_FAILED';

  static readonly REMOVE_SOME_TASKS_START = '[WkfSupervisionSearch]: REMOVE_SOME_TASKS_START';
  static readonly REMOVE_SOME_TASKS_SUCCEEDED = '[WkfSupervisionSearch]: REMOVE_SOME_TASKS_SUCCEEDED';
  static readonly REMOVE_SOME_TASKS_FAILED = '[WkfSupervisionSearch]: REMOVE_SOME_TASKS_FAILED';
}

export const loadResultItemsStartAction = createAction(WkfSupervisionSearchResultConstantAction.LOAD_RESULT_ITEMS_START);
export const loadResultItemsSucceededAction = createAction(WkfSupervisionSearchResultConstantAction.LOAD_RESULT_ITEMS_SUCCEEDED,props<{payload:EsPage<CdxTask>}>());
export const loadResultItemsFailedAction = createAction(WkfSupervisionSearchResultConstantAction.LOAD_RESULT_ITEMS_FAILED,props<{error:Error}>());
export const loadAggregateStartAction = createAction(WkfSupervisionSearchResultConstantAction.LOAD_AGGREGATE_START);
export const loadAggregateSucceededAction = createAction(WkfSupervisionSearchResultConstantAction.LOAD_AGGREGATE_SUCCEEDED,props<{payload:EsPage<CdxTask>}>());
export const loadAggregateFailedAction = createAction(WkfSupervisionSearchResultConstantAction.LOAD_AGGREGATE_FAILED,props<{error:Error}>());
export const updateTasksStartAction = createAction(WkfSupervisionSearchResultConstantAction.UPDATE_TASKS_START);
export const updateTasksSucceededAction = createAction(WkfSupervisionSearchResultConstantAction.UPDATE_TASKS_SUCCEEDED,props<{payload:EsPage<CdxTask>}>());
export const updateTasksFailedAction = createAction(WkfSupervisionSearchResultConstantAction.UPDATE_TASKS_FAILED,props<{error:Error}>());
export const updateTaskSucceededAction = createAction(WkfSupervisionSearchResultConstantAction.UPDATE_TASK_SUCCEEDED, props<{payload:EsPage<CdxTask>}>());
export const updateSomeTasksStartAction = createAction(WkfSupervisionSearchResultConstantAction.UPDATE_SOME_TASKS_START);
export const updateSomeTasksSucceededAction = createAction(WkfSupervisionSearchResultConstantAction.UPDATE_SOME_TASKS_SUCCEEDED,props<{payload:CdxTask[]}>());
export const updateSomeTasksFailedAction = createAction(WkfSupervisionSearchResultConstantAction.UPDATE_SOME_TASKS_FAILED,props<{error:Error}>());
export const removeSomeTasksStartAction = createAction(WkfSupervisionSearchResultConstantAction.REMOVE_SOME_TASKS_START);
export const removeSomeTasksSucceededAction = createAction(WkfSupervisionSearchResultConstantAction.REMOVE_SOME_TASKS_SUCCEEDED,props<{payload:CdxTask[]}>());
export const removeSomeTasksFailedAction = createAction(WkfSupervisionSearchResultConstantAction.REMOVE_SOME_TASKS_FAILED,props<{error:Error}>());


@Injectable({
  providedIn: 'root'
})
export class WkfSupervisionSearchResultAction {


  constructor( private localStore: Store ) {
  }

  public loadTasksStarted() {
    this.localStore.dispatch(loadResultItemsStartAction());
  }

  public loadTasksSucceeded(payload: EsPage<CdxTask>) {
    this.localStore.dispatch(loadResultItemsSucceededAction({payload}));
  }

  public loadTasksFailed(error: any) {
    this.localStore.dispatch(loadResultItemsFailedAction({error}));
  }



  public loadAggregateStart() {
    this.localStore.dispatch(loadAggregateStartAction());
  }

  public loadAggregateFailed(error: any) {
    this.localStore.dispatch(loadAggregateFailedAction({error}));
  }

  public loadAggregateSucceeded(agg: Aggregate) {
    const payload: EsPage<CdxTask> = new EsPage<CdxTask>(0, [], 0, 0, [agg], false);
    this.localStore.dispatch(loadAggregateSucceededAction({payload}));
  }

  public updateTasksStarted() {
    this.localStore.dispatch(updateTasksStartAction());
  }

  public updateTasksSucceeded(payload: EsPage<CdxTask>) {
    this.localStore.dispatch(updateTasksSucceededAction({payload}));
  }

  public updateTasksFailed(error: any) {
    this.localStore.dispatch(updateTasksFailedAction({error}));
  }

  updateTaskSucceeded( cdxTask: CdxTask ) {
    const page: EsPage<CdxTask> = new EsPage<CdxTask>(0, [cdxTask], 0, 0, [], false);
    this.localStore.dispatch(updateTaskSucceededAction({payload: page}));
  }

  public updateSomeTasksStarted() {
    this.localStore.dispatch(updateSomeTasksStartAction());
  }

  public updateSomeTasksSucceeded(payload: CdxTask[]) {
    this.localStore.dispatch(updateSomeTasksSucceededAction({payload}));
  }

  public updateSomeTasksFailed(error: any) {
    this.localStore.dispatch(updateSomeTasksFailedAction({error}));
  }

  public removeSomeTasksStarted() {
    this.localStore.dispatch(removeSomeTasksStartAction());
  }

  public removeSomeTasksSucceeded(payload: CdxTask[]) {
    this.localStore.dispatch(removeSomeTasksSucceededAction({payload}));
  }

  public removeSomeTasksFailed(error: any) {
    this.localStore.dispatch(removeSomeTasksFailedAction({error}));
  }
}
